// @ts-nocheck

import memoize from 'memoize-state';
import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useMergeProps from '../../../hooks/useMergeProps';
import { clearChecks as clearChecksAction } from '../actions/basket';
import GridsResetSelection from '../components/pool/GridsResetSelection';
import Selection from '../states/selection';

const legacySelector = memoize((state, { selectionIndex }) => {
  const { selections } = state.grids.basket;
  const selection = selections[selectionIndex];
  const isHighlight = Selection.hasEnoughChecks(selection);
  return { isHighlight };
});

type GridsResetSelectionContainerProps = {
  className?: string;
  selectionIndex: number;
};

const GridsResetSelectionContainer = ({ selectionIndex, ...ownProps }: GridsResetSelectionContainerProps) => {
  const dispatch = useDispatch();

  const selectedProps = useSelector((state) => legacySelector(state, { selectionIndex }));

  const clearChecks = useCallback(() => {
    dispatch(clearChecksAction(selectionIndex));
  }, [dispatch, selectionIndex]);

  const otherProps = useMemo(
    () => ({
      clearChecks,
    }),
    [clearChecks],
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  return <GridsResetSelection {...enhancedProps} />;
};

export default GridsResetSelectionContainer;
